module.exports = __webpack_public_path__ + "officialStatic/img/tkq.4d8a3ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/role/tkq.png
// module id = Ffke
// module chunks = 0